import { render } from "./XQuadrant.vue?vue&type=template&id=08fba6a4&scoped=true"
import script from "./XQuadrant.vue?vue&type=script&lang=js"
export * from "./XQuadrant.vue?vue&type=script&lang=js"

import "./XQuadrant.vue?vue&type=style&index=0&id=08fba6a4&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fba6a4"]])

export default __exports__